import React from 'react';
import { useTranslation } from 'react-i18next';
import WorkflowMessagePanel from '../WorkflowMessagePanel';
import { Utils } from '../../services';
import { getWorkflowCompletionContent } from '../../services/workflowCompletionUtils';

const WorkflowCompletion = ({ workflow, containerRef }) => {
    const { t, i18n } = useTranslation();
    const lang = Utils.i18nUiLang(i18n);
    const { mainHtml, extraMessages } = getWorkflowCompletionContent(workflow, lang, t);

    return (
        <div className="WorkflowRunner WorkflowRunner--completed" ref={containerRef}>
            <WorkflowMessagePanel mainHtml={mainHtml} extraMessages={extraMessages} />
        </div>
    );
};

export default WorkflowCompletion;
